import apiReq from 'core/api';
import {
  JiraCredentials,
  JiraFilterResponse,
  JiraProject,
  JiraIssuesPreviewRequest,
  JiraIssuesPreviewResponse,
  JiraSaveIssuesRequest,
  JiraIssue,
} from './types';

export const updateJiraCredentials = async (credentials: JiraCredentials): Promise<void> => {
  await apiReq('user/update-jira-credentials', 'POST', credentials);
};

export const getJiraFilter = async (projectId: string): Promise<JiraFilterResponse> => {
  const url = `jira/filter?project_id=${projectId}`;
  const response = await apiReq<JiraFilterResponse>(url, 'GET');
  if (!response) {
    throw new Error('Не удалось получить данные фильтра Jira');
  }
  return response;
};

export const getJiraProjects = async (): Promise<JiraProject[]> => {
  const response = await apiReq<JiraProject[]>('jira/projects', 'GET');
  return response || [];
};

export const getJiraIssuesPreview = async (
  params: JiraIssuesPreviewRequest
): Promise<JiraIssuesPreviewResponse> => {
  const requestBody: any = {
    project_id: params.project_id,
    offset: params.offset,
    limit: params.limit,
    jira_project_key: params.jira_project_key,
  };

  if (params.status) requestBody.status = params.status;
  if (params.reporter) requestBody.reporter = params.reporter;
  if (params.assignee) requestBody.assignee = params.assignee;

  const response = await apiReq<JiraIssuesPreviewResponse>(
    'jira/issues/search',
    'POST',
    requestBody
  );
  if (!response) {
    throw new Error('Не удалось получить список задач');
  }
  return response;
};

export const getJiraSavedIssues = async (projectId: string): Promise<JiraIssue[]> => {
  const url = `jira/issues/saved?project_id=${projectId}`;
  const response = await apiReq<JiraIssue[]>(url, 'GET');
  return response || [];
};

export const saveJiraIssues = async (request: JiraSaveIssuesRequest): Promise<void> => {
  await apiReq('jira/issues/save', 'POST', request);
};

export interface JiraSyncIssuesRequest {
  project_id: string;
  keys: string[];
}

export interface JiraDeleteIssuesRequest {
  project_id: string;
  keys: string[];
}

export const syncJiraIssues = async (request: JiraSyncIssuesRequest): Promise<void> => {
  await apiReq('jira/issues/sync', 'POST', request);
};

export const deleteJiraIssues = async (request: JiraDeleteIssuesRequest): Promise<void> => {
  await apiReq('jira/issues/delete', 'POST', request);
};
